import { compose, withContext, withState } from 'recompose';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import TimeEntry from './timeEntry';

const enhance = compose(
  withNamespaces(['common', 'tasks']),
  withState('selectedTimeEntryId', 'setSelectedTimeEntryId', 0),
  withContext(
    {
      setSelectedTimeEntryId: PropTypes.func.isRequired,
      selectedTimeEntryId: PropTypes.number.isRequired,
    }, props => ({
      selectedTimeEntryId: props.selectedTimeEntryId,
      setSelectedTimeEntryId: props.setSelectedTimeEntryId,
    }),
  ),
);
export default enhance(TimeEntry);
